import { lazy } from "react";
import { useRouteError } from "react-router-dom";

function RouteErrorFallback() {
      const error = useRouteError();
      return (
            <div className="container-xl py-5 text-center">
                  <h3 className="text-danger">Error al cargar el módulo</h3>
                  <p className="text-muted">{error?.message || "No se pudo cargar la página."}</p>
                  <button className="btn btn-primary" onClick={() => window.location.reload()}>
                        Recargar página
                  </button>
            </div>
      );
}

const VentasCarroProviderLayout = lazy(() =>
      import("../../ventas/carro/VentasCarroProviderLayout.jsx")
);

const CarroLayout = lazy(() =>
      import("../../ventas/carro/CarroLayout.jsx")
);

const NotasCreditoLayout = lazy(() =>
      import("../../notas_credito/NotasCreditoLayout.jsx")
);

const NotasCreditoList = lazy(() =>
      import("../../notas_credito/NotasCredito.jsx")
);

const NotaCreditoForm = lazy(() =>
      import("../../notas_credito/NotaCreditoForm.jsx")
);

const NotasDebitoLayout = lazy(() =>
      import("../../notas_debito/NotasDebitoLayout.jsx")
);

const NotasDebitoList = lazy(() =>
      import("../../notas_debito/NotasDebito.jsx")
);

const NotaDebitoForm = lazy(() =>
      import("../../notas_debito/NotaDebitoForm.jsx")
);

const CambioExpress = lazy(() =>
      import("../../ventas/carro/CambioExpress.jsx")
);

const Cotizaciones = lazy(() =>
      import("../../cotizaciones/Cotizaciones.jsx")
);

const ArriendoAfectoExentoTool = lazy(() =>
      import("../../tool/ArriendoAfectoExentoTool.jsx")
);

const ventasRoutes = [
      {
            path: "ventas",
            element: <VentasCarroProviderLayout />,
            children: [
                  {
                        index: true,
                        element: <CarroLayout />,
                  },
                  {
                        path: "cambios",
                        element: <CambioExpress />,
                  },
                  {
                        path: "cotizaciones",
                        element: <Cotizaciones />,
                  },
                  {
                        path: "tool/arriendo",
                        element: <ArriendoAfectoExentoTool />,
                  },
                  {
                        path: "notas-credito",
                        element: <NotasCreditoLayout />,
                        children: [
                              { index: true, element: <NotasCreditoList /> },
                              { path: "nueva", element: <NotaCreditoForm /> },
                              { path: "editar/:token", element: <NotaCreditoForm /> },
                        ]
                  },
                  {
                        path: "notas-debito",
                        element: <NotasDebitoLayout />,
                        errorElement: <RouteErrorFallback />,
                        children: [
                              { index: true, element: <NotasDebitoList /> },
                              { path: "nueva", element: <NotaDebitoForm /> },
                              { path: "editar/:token", element: <NotaDebitoForm /> },
                        ]
                  },
            ],
      },
];

export default ventasRoutes;